import CartConfirmation from './CartConfirmation';

export default CartConfirmation;
